import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgFolderCloudFilledIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <g fill="currentColor" clipPath="url(#FolderCloudFilledIcon_svg__a)">
        <path d="M0 2.75A.75.75 0 0 1 .75 2h3.922c.729 0 1.428.29 1.944.805L7.811 4h7.439a.75.75 0 0 1 .75.75v5.02a4.4 4.4 0 0 0-.921-.607 5.11 5.11 0 0 0-9.512-.753A4.75 4.75 0 0 0 2.917 14H.75a.75.75 0 0 1-.75-.75V2.75Z" />
        <path
          fillRule="evenodd"
          d="M6.715 9.595a3.608 3.608 0 0 1 7.056.688C15.07 10.572 16 11.739 16 13.107 16 14.688 14.757 16 13.143 16a2.795 2.795 0 0 1-.107 0H7.32a.757.757 0 0 1-.163-.018 3.25 3.25 0 0 1-.443-6.387Zm.703 4.905a1.75 1.75 0 0 1-.03-3.497.75.75 0 0 0 .7-.657 2.108 2.108 0 0 1 4.198.261v.357c0 .415.335.75.75.75h.107c.753 0 1.357.607 1.357 1.393s-.604 1.393-1.357 1.393c-.024 0-.047 0-.07-.002a.736.736 0 0 0-.1.002H7.418Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="FolderCloudFilledIcon_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const FolderCloudFilledIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgFolderCloudFilledIcon} />;
});
FolderCloudFilledIcon.displayName = 'FolderCloudFilledIcon';
export default FolderCloudFilledIcon;
